/*
  v-clickaway directive

  defines a directive which registers handlers to detect clicks outside of the
  target element. Good for automatically closing dialogs, menus etc when the
  user clicks away.

  usage:

  <element v-clickaway="onClickaway" />
  or
  <element v-clickaway="{ elements: [other, divs], handler: onClickaway }" />

  where onClickaway is an event handler to call when the user clicks away,
  and the [other, divs] are an array of Vue or DOM elements to consider part
  of the target (i.e. a click on these elements does *not* trigger a clickaway)
*/

function setupBinding (el, binding) {
  // remove any stale event handlers
  if (el && el._f_clickawayHandler) {
    document.body.removeEventListener('click', el._f_clickawayHandler, true)
    delete el._f_clickawayHandler
  }
  let includedElements = []
  let handler = () => {}
  if (el && binding.value) {
    if (binding.value.elements) includedElements = binding.value.elements
    if (binding.value.handler) handler = binding.value.handler
    else if (typeof binding.value === 'function') handler = binding.value
    includedElements.push(el)

    el._f_clickawayHandler = (e) => {
      // check if click event falls within any of the included elements
      var outside = includedElements.reduce((outside, el) => {
        const rawElement = el ? el.$el || el : null
        return outside && !(rawElement && (rawElement === e.target || (rawElement.contains && rawElement.contains(e.target))))
      }, true)
      // if not, call the event handler
      if (outside) handler()
    }
    document.body.addEventListener('click', el._f_clickawayHandler, true)
  }
}

export default {
  register (Vue) {
    Vue.directive('clickaway', {
      // binding added or changed
      bind: setupBinding,
      update: setupBinding,
      unbind (el) {
        // Clean up when the directive is removed or destroyed
        if (el && el._f_clickawayHandler) {
          document.body.removeEventListener('click', el._f_clickawayHandler, true)
          delete el._f_clickawayHandler
        }
      }
    })
  }
}
